import { Component, OnInit, Inject } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { forEach } from '@angular/router/src/utils/collection';
@Component({
  selector: 'app-confirmacion',
  templateUrl: './confirmacion.component.html',
  styleUrls: ['./confirmacion.component.css']
})
export class ConfirmacionComponent implements OnInit {

  displayedColumns: string[] = ['select', 'nombre', 'correo', 'tipo'];
  dataSource: any = [];
  constructor(
    private dialogRef: MatDialogRef<ConfirmacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private snackbar: MatSnackBar,
    private localSave: LocalSaveService,
    private gateway: GatewayService,
    private spinner: NgxSpinnerService
  ) { }

  mensaje: any = '';
  contratas: any = [];

  grupoVal = new FormGroup({
    COMENTARIO: new FormControl('', Validators.compose([
      Validators.required
    ]))
  });

  async ngOnInit() {
    let datos: any = this.data;

    if (datos.msj) {
      this.mensaje = '¿Seguro que desea ' + datos.msj + '?';
    }
    else if (datos.sms) {
      this.mensaje = '¿Seguro que desea ' + datos.sms + '?';
      if (!datos.addcomment) {
        this.grupoVal = new FormGroup({
        });
      }

      if (datos.changenumber) {
        this.grupoVal = new FormGroup({
          TELEFONO_ALTERNO: new FormControl(
            this.data.cliente.telefono_alterno,
            Validators.compose([
              Validators.required,
              Validators.pattern(/^[0-9]*$/),   // Solo números
              Validators.minLength(8),          // Mínimo 8 dígitos
              Validators.maxLength(8)           // Máximo 8 dígitos
            ])
          ),
          TELEFONO_SELECCIONADO: new FormControl('')
        });
      }
    }
    else if (datos.msg) {
      this.mensaje = '¿Seguro que desea ' + datos.msg + '?';
      await this.getContratas();
    }
    else {
      this.mensaje = '¿Seguro que desea borrar?';
    }

  }

  getTelefonoFinal() {
    const seleccion = this.grupoVal.value.TELEFONO_SELECCIONADO;

    return seleccion === 'principal'
      ? this.data.cliente.telefono
      : this.grupoVal.value.TELEFONO_ALTERNO;
  }

  puedeConfirmar() {
    const seleccion = this.grupoVal.value.TELEFONO_SELECCIONADO;

    // Si eligió el principal → siempre habilitado
    if (seleccion === 'principal') return true;

    // Si eligió el alterno → habilitar solo si el campo es válido
    return this.grupoVal.controls.TELEFONO_ALTERNO.valid;
  }

  close() {
    this.dialogRef.close({ resp: false });
  }

  getContratas() {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.gateway.get('getdistribuidor',
        {
          IDPADRE: this.localSave.get('usuarioPGV').IDU,
          IDAREA: this.localSave.get('usuarioPGV').IDAREA,
          NUM_PAGINA: 0,
          FILTRO: null,
          NUM_ELEMENTOS: 10000,
          IDPAIS: 5
        })
        .then((result: any) => {
          let aux: any = result;
          this.contratas = aux.rows;
          this.dataSource = this.contratas;
          this.spinner.hide();
          resolve(true);
        }).catch((e: any) => {
          this.spinner.hide();
          resolve(false);
        });
    });
  }

  select_serv(element: any, event: Event) {
    if (event) {
      // alert('hola')
      event.stopPropagation();
    }

    const distribuidor = this.contratas.find(item => item.iddistribuidor === element.iddistribuidor);
    if (distribuidor) {
      distribuidor.check = distribuidor.check == 1 ? 0 : 1;
    }
    this.dataSource = this.contratas;
  }

  evitarCheck(event: MouseEvent) {
    // Evita que el checkbox cambie de estado
    event.preventDefault();
  }

  delete() {
    let datos: any = this.data;

    if (datos.snackb) {
      this.gateway.deleteAgente(this.data.operacion, this.data.id, datos.snackb, this.grupoVal.controls.COMENTARIO.value).then((result) => {
        this.dialogRef.close(true);
      }
      ).catch(function (e) {
      });
    } else if (datos.sms) {
      this.dialogRef.close({ resp: true, comentario: datos.addcomment ? this.grupoVal.controls.COMENTARIO.value : null, telefono_envio: this.getTelefonoFinal() });
    }
    else if (datos.msj) {
      this.dialogRef.close({ resp: true, comentario: this.grupoVal.controls.COMENTARIO.value, ...this.data.id, operacion: this.data.operacion });
    }
    else if (datos.msg) {
      this.spinner.show();

      const checkOnes = this.contratas.filter(item => item.check === 1);
      if (checkOnes.length > 0) {
        this.data.id.contratas = checkOnes;

        // console.log('------ verificar -----------')
        // console.log(this.contratas);
        // this.spinner.hide();

        this.gateway.delete(this.data.operacion, this.data.id, 'La transacción se realizó con éxito.').then((result) => {
          //console.log(result)
          this.dialogRef.close(true);
        }
        ).catch(function (e) {
        });
      } else {
        this.spinner.hide();
        this.snackbar.open(`Debe seleccionar al menos una contrata antes de proceder.`, 'Cerrar', { duration: 5000 });
      }

    }
    else {
      this.spinner.show();
      this.gateway.delete(this.data.operacion, this.data.id, 'Eliminado con éxito').then((result) => {
        //console.log(result)
        this.dialogRef.close(true);
      }
      ).catch(function (e) {
      });
    }

  }

}
